import React, { useEffect, useState } from "react";
import Constants from "../../constants/Constants";
import { FiTag } from "react-icons/fi";
import { Link } from "@reach/router";
const Tags = ({ id, siteid }) => {
  const [tags, setTags] = useState([]);
  useEffect(() => {
    fetch(`${Constants.API}get-tags.php?v=${id}`, { credentials: "include" })
      .then((res) => res.json())
      .then((res) => {
        //handle
        if ("success" in res) {
          setTags(res.success);
        }
      });
  }, [id]);
  return (
    <div className="tagsContainer">
      <div className="tagTitle">
        <FiTag style={{ marginRight: 6 }} /> Tags
      </div>
      <div className="allTags">
        {tags.map((tag) => (
          <div className="tagItem" key={`tag-${tag.hashtag_id}`}>
            <Link
              to={`${Constants.MA}tagged/${tag.hash_tag}`}
              state={{ fromFriend: siteid }}
            >
              #{tag.hash_tag}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tags;
